import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";
import {  useLeaves } from "./provider";

function Leaves() {


  return <Layout><Outlet /></Layout>;
}

export default Leaves;
